import { useContext } from 'react';

import DiscountTag from 'components/common/DiscountTag';
import Text from 'components/common/Text';
import { UserContext } from 'components/signUpFunnel/Contexts';

const MobileOrderSummaryHeader = ({ box, defaultPlanDetails = null }) => {
  const { user } = useContext(UserContext);

  const hasSmsDiscount = user?.smsDiscount && box?.smsIncentivePromo;
  const hasPromoDiscount = box?.promoApplied;

  let discountText;

  if (hasPromoDiscount && hasSmsDiscount) {
    discountText = (
      <span className="inline-flex items-center">
        <DiscountTag discountText="5% off" />
        <DiscountTag discountText={box?.promo.displayedDiscount} />
      </span>
    );
  } else if (hasPromoDiscount) {
    discountText = <DiscountTag discountText={box?.promo.displayedDiscount} />;
  } else if (hasSmsDiscount) {
    discountText = <DiscountTag discountText="5% off" />;
  } else {
    discountText = defaultPlanDetails;
  }

  return (
    <>
      <Text brandStylesOverrides="h7 text-secondary" className="m-0 flex flex-wrap items-center">
        {discountText}
        {box?.promo?.maxDiscount && (
          <span className="textSm">{` (up to ${box?.promo?.maxDiscount})`}</span>
        )}
      </Text>

      {hasPromoDiscount ? (
        <Text htmlElement="span" className="inline-flex items-center">
          <Text htmlElement="span" className="textSm text-charcoal-90 line-through">
            {box?.subtotalFormatted}
          </Text>
          <Text htmlElement="span" className="ml-2" brandStylesOverrides="h5 text-charcoal-100">
            {box?.promo.subtotalFormatted}
          </Text>
        </Text>
      ) : hasSmsDiscount ? (
        <Text htmlElement="span" className="inline-flex items-center">
          <Text htmlElement="span" className="font-medium text-charcoal-90 line-through">
            {box?.subtotalFormatted}
          </Text>
          <Text htmlElement="span" className="ml-2" brandStylesOverrides="h5 text-charcoal-100">
            {box?.smsIncentivePromo.subtotalFormatted}
          </Text>
        </Text>
      ) : (
        <Text brandStylesOverrides="h5 text-charcoal-100">{box?.subtotalFormatted}</Text>
      )}
    </>
  );
};

MobileOrderSummaryHeader.propTypes = {
  box: PropTypes.shape({
    promoApplied: PropTypes.bool.isRequired,
    promo: PropTypes.shape({
      subtotalFormatted: PropTypes.string,
      subtotalCents: PropTypes.number,
      pricePerServingFormatted: PropTypes.string,
      displayedDiscount: PropTypes.string,
      maxDiscount: PropTypes.string,
    }),
    subtotalFormatted: PropTypes.string,
    pricePerServingFormatted: PropTypes.string,
    smsIncentivePromo: PropTypes.shape({
      subtotalCents: PropTypes.number,
      subtotalFormatted: PropTypes.string,
    }),
  }),
  defaultPlanDetails: PropTypes.node,
};

export default MobileOrderSummaryHeader;
